import React from "react";
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";

function useFinancialReportRow(showAccountNumber: boolean = false) {
  const descriptionFormatter = React.useCallback(
    (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
      if (!showAccountNumber || !row.isAccount || Number.isNaN(row.detailedDescription))
        return row.description as string;
      return `${row.detailedDescription} - ${row.description}`;
    },
    [showAccountNumber]
  );
  return { descriptionFormatter };
}

export default useFinancialReportRow;
